import styled from 'styled-components';
import { padding } from 'shared/variables';

export const Container = styled.div`
  padding: 87px ${padding.desktop}px;
`;
